__turbopack_context__.v({
  "container": "TokensPage-module__Hj0I0q__container",
  "emptyState": "TokensPage-module__Hj0I0q__emptyState",
  "filterButton": "TokensPage-module__Hj0I0q__filterButton",
  "header": "TokensPage-module__Hj0I0q__header",
  "pageButton": "TokensPage-module__Hj0I0q__pageButton",
  "pageButtonActive": "TokensPage-module__Hj0I0q__pageButtonActive",
  "pagination": "TokensPage-module__Hj0I0q__pagination",
  "shimmer": "TokensPage-module__Hj0I0q__shimmer",
  "skeleton": "TokensPage-module__Hj0I0q__skeleton",
  "table": "TokensPage-module__Hj0I0q__table",
  "tableContainer": "TokensPage-module__Hj0I0q__tableContainer",
  "title": "TokensPage-module__Hj0I0q__title",
  "tokenIcon": "TokensPage-module__Hj0I0q__tokenIcon",
  "tokenIconPlaceholder": "TokensPage-module__Hj0I0q__tokenIconPlaceholder",
  "tokenInfo": "TokensPage-module__Hj0I0q__tokenInfo",
  "tokenName": "TokensPage-module__Hj0I0q__tokenName",
  "tokenSymbol": "TokensPage-module__Hj0I0q__tokenSymbol",
  "typeBadge": "TokensPage-module__Hj0I0q__typeBadge",
});
